import request from "@/hooks/useRequest";

// 地区list
export const getAreaListApi = (params) => {
  return request("/web-wallet/api/v1/kyc/area-list", { params });
};

// s3 put url
export const getS3PutUrlApi = (params) => {
  return request("/web-wallet/api/v1/s3/get-private-put-url", { params });
};

// 用户信息
export const getUserInfoApi = () => {
  return request("/web-wallet/api/v1/account/user/info");
};

// 发送手机验证码
export const getPhoneCodeApi = (body) => {
  return request("/web-wallet/api/v1/phone/send-code", { body });
};

// 发送邮箱验证码
export const getEmialCodeApi = (body) => {
  return request("/web-wallet/api/v1/email/code/get", { body });
};

// 验证邮箱code码
export const postEmailVerifyApi = (body) => {
  return request("/web-wallet/api/v1/account/email/verify", { body });
};

// 币种列表
// 场景: 可选项 "deposit", "withdraw", or "account_transfer".
export const getCurrencyListApi = ({ scene }) => {
  return request("/web-wallet/api/v1/currency/list");
};

//修改用户信息
export const postUpdateUserInfoApi = (body) => {
  return request("/web-wallet/api/v1/account/user/update", { body });
};

// s3 key 换url
export const getS3UrlApi = (params) => {
  return request("/web-wallet/api/v1/s3/get-private-url", { params });
};

//获取需要校验的安全要素项
export const getAccountValidationItemsApi = (body) => {
  return request("/web-wallet/api/v1/account/validation/items", { body });
};

//发送手机验证码
export const postGetPhoneCodeApi = (body) => {
  return request("/web-wallet/api/v1/phone/send-code", { body });
};

//验证手机code
export const postVerifyPhoneCodeApi = (body) => {
  return request("/web-wallet/api/v1/account/phone/verify", { body });
};
